import React, { Fragment, useEffect } from 'react'
import { Route } from 'react-router-dom'
import Navigation from './navigation/navigation.container'
import Cover from './cover/cover.container'
import Works from './works/works.container'
import Assessment from './assessment/assessment.container'
import posthog from 'posthog-js'

const AssessmentFile = ({ classes }) => {
  useEffect(() => {
    posthog.capture('accessed assessment file', {
      $set: { moderationUser: true }
    })
  }, [])

  return (
    <Fragment>
      <Navigation />
      <Route
        exact
        path="/assessment-files/:assessmentFileId"
        component={Cover}
      />
      <Route
        exact
        path="/assessment-files/:assessmentFileId/works"
        component={Works}
      />
      <Route
        exact
        path="/assessment-files/:assessmentFileId/works/:workId"
        component={Assessment}
      />
    </Fragment>
  )
}

export default AssessmentFile
